import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Landing } from './landing.model';
import { Slide } from './slide.model';

@Injectable()
export class LandingFormService {
  constructor(private fb: FormBuilder) {}

  getForm(landing: Landing = new Landing()): FormGroup {
    return this.fb.group({
      _id: [landing._id],
      name: [landing.name, Validators.required],
      slug: [landing.slug, Validators.required],
      banner: [landing.banner],
      description: [landing.description],      
      active: [landing.active],
      slides: this.fb.array(landing.slides.map(item => this.getSlideForm(item)))
    });  
  }

  getSlideForm(slide: Slide = new Slide()): FormGroup {
    return this.fb.group({
      _id: [slide._id],
      image: [slide.image],
      content: [slide.content],
      background: [slide.background],
      backgroundPosition: [slide.backgroundPosition],
      mode: [slide.mode],
      position: [slide.position],
      active: [slide.active]
    });
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/landings/shared/landing-form.service.ts